import Select from 'antd/lib/select';
import 'antd/lib/select/style/css';

export default Select;
